import { IFilterValue } from './types'

export const defaultLimitShowCount = 10
export const defaultLimitAggregationCount = 20

export const hightestDevStatusFieldMap = {
  HIGHEST_DEV_STATUS_BEFORE_TERMINATION_CN: 'HIGHEST_DEV_STATUS_CN',
  HIGHEST_DEV_STATUS_CN: 'HIGHEST_DEV_STATUS_CN',
  GLOBAL_HIGHEST_DEV_STATUS_BEFORE_TERMINATION: 'GLOBAL_HIGHEST_DEV_STATUS',
  GLOBAL_HIGHEST_DEV_STATUS: 'GLOBAL_HIGHEST_DEV_STATUS',
}

export const hightestDevStatusInactivePhaseCondition: IFilterValue[] = [
  {
    display_name_cn: '无进展',
    display_name_en: 'Pending',
    value: '4d95bf5fb0c340fbb38cda626c1c9c60',
  },
  {
    display_name_cn: '终止',
    display_name_en: 'Discontinued',
    value: 'a5183ad464de4fe9bb9a3583425ae4a2',
  },
  {
    display_name_cn: '暂停',
    display_name_en: 'Suspended',
    value: 'cf139751c1fd4a5892c786230e6f6b6a',
  },
]
